import * as React from 'react';

interface DelayUnmountingProps {
    shouldShow: boolean
    delayTime?: number
}

export default function delayUnmounting<P extends object>(Component) {
    return class extends React.Component<P & DelayUnmountingProps> {
        state = {
            shouldRender: (this.props).shouldShow
        };

        componentDidUpdate(prevProps) {
            if (prevProps.shouldShow && !(this.props).shouldShow) {
                setTimeout(
                    () => this.setState({ shouldRender: false }),
                    (this.props).delayTime ? (this.props).delayTime : 450
                );
            } else if (!prevProps.shouldShow && (this.props).shouldShow) {
                this.setState({ shouldRender: true });
            }
        }

        render() {
            return this.state.shouldRender ? <Component {...this.props} /> : null;
        }
    };
}